import * as UserRoutes from './UserRoutes';
import * as CreativesRoutes from './CreativesRoutes';
import * as CategoriesRoutes from './CategoriesRoutes';
import * as InstagramRoutes from './InstagramRoutes';
import * as AdminRoutes from './AdminRoutes';

export const ApiRoutes = {
  User: UserRoutes,
  Creatives: CreativesRoutes,
  Categories: CategoriesRoutes,
  Instagram: InstagramRoutes,
  Admin: AdminRoutes,
} as const;
